<template>
	<section class="aui-flexView">
		<div class="header">
			<div class="headerLogo">
				<div class="header-163logo">
					<img src="../img/schoollogo.png" alt="logo" />
				</div>
			</div>
			<div class="headerTitleAll">
				<p class="headerTitle">国立木浦大学ㅤ前置课程</p>
				<p class="headerTitle2">국립목포대학교ㅤ 선수과목</p>
			</div>
			<div class="headerNav">
				<a>中文</a>
				<router-link id="LoginHan" to="/LoginHan" target="_blank">한국어</router-link>
			</div>
		</div>

		<div class="main-inner-wrap">
			<div id="loginBlock" class="login tab-2">


				<div id="normalLoginTab" class="loginForm" style="display: block;">
					<h2 class="loginbox-title">学生帐号登录</h2>

					<div class="loginWrap" data-vv-scope="login_form">
						<div class="m-header"></div>
						<div class="inputbox">
							<div class="u-logo">
								<div class="u-logo-img1"></div>
							</div>
							<div class="u-input">
								<input data-placeholder="输入用户名" name="account" v-model="login.account"
									v-validate="required" type="text" placeholder="输入用户名" style="width: 200px;">
							</div>
						</div>
						<div class="fur-change-email"></div>
						<div class="inputbox">
							<div class="u-logo">
								<div class="u-logo-img2"></div>
							</div>
							<div class="u-input box">
								<input data-placeholder="输入密码" name="password" v-model="login.password"
									v-validate="required" maxlength="50" type="password" placeholder="输入密码">
							</div>
							<div class="u-tip" id="auto-id-1582599459541" style="display: none;">
								<div class="u-success u-clear"></div>
							</div>
						</div>
						<!-- <div class="m-unlogin">
							<div class="b-unlogn">
								<span class="u-checkbox tabfocus">
									<input id="un-login" type="checkbox" name="un-login" class="Logincheckbox">
								</span>
								<label>记住用户名和密码</label>
							</div>
						</div> -->

						<div style="height:30px;"></div>


						<div class="inputbox" style="width:180px;display: inline-block;">
							<div class="u-input">
								<input data-placeholder="验证码" v-model="yzmcode" name="checkcode" id="yzcode"
									class="u-inputyzm" type="text" style="width: 180px;margin-left: 0px;"
									placeholder="验证码">
							</div>
						</div>
						<div class="ckimgbox">
							<canvas id="canvas" width="150" height="40"></canvas>
						</div>

						<div class="loginbox">
							<a href="javascript:;" @click="loginsubmit()">登&nbsp;&nbsp;录</a>
						</div>




					</div>
				</div>

			</div>
		</div>


		<div id="wrapper">
			<div id="pager">
				<div class="cf" style="position: relative;">
					<!--轮播图开始-->
					<div class="top-banner">
						<div id="slideBox" class="slideBox banner-container">
							<div class="hd banner-pagination">
								<ul>
									<li class="swiper-pagination-switch"></li>
									<li class="swiper-pagination-switch"></li>
									<li class="swiper-pagination-switch"></li>
									
								</ul>
							</div>
							<div class="bd">
								<ul>
									<li><img src="../img/banner01.jpg" />
									</li>
									<li><img src="../img/banner02.jpg" />
									</li>
									<li><img src="../img/banner03.jpg" />
									</li>
									
								</ul>
							</div>
						</div>
					</div>
					<!--轮播图结束-->
				</div>
			</div>


		</div>






		<div id="footer" class="m-footer">
			<div class="footer-main">
				<div class="footer-certification">
					<span class="copyright">
						版权所有:木浦大学Copyright@ Mokpo National University, Allrights reserved
					</span>

				</div>
			</div>
		</div>
	</section>
</template>



<script>
	import mui from '../js/mui.js'
	import CryptoJS from "crypto-js"
	const encodeFactor = '7ae9badb102e03f1'



	import {
		login
	} from "../../src/api/api.js";
	import {
		yzm
	} from "../../src/api/api.js";

	import '../../src/js/jquery-1.11.0.js';
	import '../../src/js/jquery.SuperSlide.2.1.1.js';
	$(function() {
		jQuery(".slideBox").slide({
			mainCell: ".bd ul",
			effect: "left",
			autoPlay: true
		});
	});

	var show_num = [];
	export default {
		name: 'app',
		data() {
			return {
				login: {
					account: '',
					password: '',
					yzmurl: '',
					yzmcode: '',
					errormessage: ''
				},
			}
		},
		mounted: function() {
			show_num = [];
			draw(show_num);
			$("#canvas").on('click', function() {
				draw(show_num);

			})


		},
		methods: {
			encrypt(txt) {
				var key = CryptoJS.enc.Utf8.parse(encodeFactor)
				var srcs = CryptoJS.enc.Utf8.parse(txt)
				var encrypted = CryptoJS.AES.encrypt(srcs, key, {
					mode: CryptoJS.mode.ECB,
					padding: CryptoJS.pad.Pkcs7
				})
				return encrypted.toString()
			},

			loginsubmit() {

				var zhanghao = this.login.account;
				var mima = this.login.password;
				var yzm = this.yzmcode;

				var num = show_num[0] + show_num[1] + show_num[2] + show_num[3];
				if (zhanghao == '' || typeof(zhanghao) == "undefined" || zhanghao == null) {
					alert('请输入账号！');
				} else if (mima == '' || typeof(mima) == "undefined" || mima == null) {
					alert('请输入密码！');
				} else if (yzm == '' || typeof(yzm) == "undefined") {
					alert('请输入验证码！');
				} else if (yzm !== num) {
					alert('验证码错误！请重新输入！');

				} else if (yzm == num) {
					

					
					var parme = {
						account: this.login.account,
						password: this.$md5(this.login.password),
						isAutoLogin: true
					}
					login(parme).then(res => {
						if (res.user !== "" && res.user !== null && typeof(res.user) !== "undefined") {
							localStorage.setItem('ss_user_access_token',res.accessToken);
							window.location.href = "https://www.mnuedu.net/kecheng.html";
						} else {
							alert("账号或密码错误！")
						}
					}).catch(err => {
						reject(err.data);
					});


				} else {
					alert('账号或密码错误！');

				}


			}




		}

	}



	//生成并渲染出验证码图形
	function draw(show_num) {
		var canvas_width = $('#canvas').width();
		var canvas_height = $('#canvas').height();
		var canvas = document.getElementById("canvas"); //获取到canvas的对象，演员
		var context = canvas.getContext("2d"); //获取到canvas画图的环境，演员表演的舞台
		canvas.width = canvas_width;
		canvas.height = canvas_height;
		var sCode =
			"a,b,c,d,e,f,g,h,i,j,k,m,n,p,q,r,s,t,u,v,w,x,y,z,A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
		var aCode = sCode.split(",");
		var aLength = aCode.length; //获取到数组的长度
		for (var i = 0; i < 4; i++) { //这里的for循环可以控制验证码位数（如果想显示6位数，4改成6即可）
			var j = Math.floor(Math.random() * aLength); //获取到随机的索引值
			// var deg = Math.random() * 30 * Math.PI / 180;//产生0~30之间的随机弧度
			var deg = Math.random() - 0.5; //产生一个随机弧度
			var txt = aCode[j]; //得到随机的一个内容
			show_num[i] = txt.toLowerCase();
			var x = 10 + i * 30; //文字在canvas上的x坐标
			var y = 20 + Math.random() * 8; //文字在canvas上的y坐标
			context.font = "bold 23px 微软雅黑";
			context.translate(x, y);
			context.rotate(deg);
			context.fillStyle = randomColor();
			context.fillText(txt, 0, 0);
			context.rotate(-deg);
			context.translate(-x, -y);
		}
		for (var i = 0; i <= 5; i++) { //验证码上显示线条
			context.strokeStyle = randomColor();
			context.beginPath();
			context.moveTo(Math.random() * canvas_width, Math.random() * canvas_height);
			context.lineTo(Math.random() * canvas_width, Math.random() * canvas_height);
			context.stroke();
		}
		for (var i = 0; i <= 30; i++) { //验证码上显示小点
			context.strokeStyle = randomColor();
			context.beginPath();
			var x = Math.random() * canvas_width;
			var y = Math.random() * canvas_height;
			context.moveTo(x, y);
			context.lineTo(x + 1, y + 1);
			context.stroke();
		}
	}
	//得到随机的颜色值
	function randomColor() {
		var r = Math.floor(Math.random() * 256);
		var g = Math.floor(Math.random() * 256);
		var b = Math.floor(Math.random() * 256);
		return "rgb(" + r + "," + g + "," + b + ")";
	}
</script>

<style>
	@import "../css/style.css";

	html {
		font-family: '\5FAE\8F6F\96C5\9ED1', 'Microsoft Yahei', '宋体';
		min-width: 1400px;
		display: block;
		overflow-y: scroll;
	}

	.Logincheckbox input[type='checkbox'] {

		color: #000000;
	}

	.main-inner-wrap {
		width: 1400px;
		margin: 0 auto;
		position: relative;
	}

	.disabled {
		background-color: #ddd;
		border-color: #ddd;
		color: #57a3f3;
		cursor: not-allowed;
	}

	.loginWrap {
		padding: 0 30px;
		width: 400px;
	}

	.loginWrap .inputbox {
		z-index: 19;
		position: relative;
		margin-bottom: 0px;
		border: 1px solid #c5cddb;
		background: #fff;
		font-size: 12px;
		line-height: 44px;
		border-color: #DADADA;
		height: 46px;
	}

	.loginWrap .inputbox .u-logo {
		float: left;
		width: 21px;
		height: 100%;
		text-align: center;
		padding: 0 5px 0 10px;
	}

	.loginWrap .inputbox .u-logo .u-logo-img1 {
		background: url(https://mimg.127.net/p/freemail/index/lib/img/urs/ico-user.png) no-repeat;
		display: inline-block;
		width: 22px;
		height: 24px;
		margin-top: 12px;
	}

	.loginWrap .inputbox .u-logo .u-logo-img2 {
		background: url(https://mimg.127.net/p/freemail/index/lib/img/urs/ico-password.png) no-repeat;
		display: inline-block;
		width: 22px;
		height: 24px;
		margin-top: 12px;
	}

	.loginWrap .inputbox .u-input {
		position: relative;
		float: left;
		margin: 0;
		padding: 0;
		outline: none;
	}

	.u-inputyzm {
		background: none;
		color: #333;
		border: 0;
		font-size: 16px;

		outline: 0;
		padding-left: 8px;

		height: 40px;
		line-height: 46px;
	}

	.loginWrap .inputbox input {
		background: none;
		color: #333;
		border: 0;
		font-size: 16px;

		outline: 0;
		margin-left: 20px;
		padding-left: 8px;

		height: 40px;
		line-height: 46px;
	}

	.loginWrap .inputbox .u-input input::-webkit-input-placeholder {
		/* placeholder颜色  */
		color: #ccc;
		/* placeholder字体大小  */
		font-size: 14px;
		font-weight: 300;
		/* placeholder位置  */
		text-align: left;
	}

	.loginWrap .fur-change-email {
		height: 22px;
		line-height: 22px;
		font-size: 0;
		position: relative;
		width: 320px;
	}

	.loginWrap .m-header {
		height: 22px;
		line-height: 22px;
		font-size: 0;
		position: relative;
		width: 320px;
	}

	.loginbox {
		margin-top: 20px;
		margin-bottom: 40px;
	}

	.loginbox a {
		cursor: pointer;
		text-align: center;
		color: #fff;
		border-radius: 4px;
		background: #009040;
		text-decoration: none;
		position: absolute;
		width: 340px;
		height: 50px;
		line-height: 50px;
		font-size: 20px;
		border: none;
	}

	.m-unlogin {
		padding-bottom: 0px;
		margin-top: 20px;
		font-size: 0;
		height: 16px;
		line-height: 16px;
	}

	.m-unlogin .b-unlogn {
		display: block;
		margin-right: 8px;
		float: left;
		border-right: none;
		width: 300px;
	}

	.m-unlogin .b-unlogn .u-checkbox {
		display: block;
		float: left;
		cursor: pointer;
		color: #999;
		font-size: 12px;
		width: 16px;
		height: 16px;

		border-radius: 2px;
	}

	.m-unlogin .b-unlogn .u-checkbox input {
		padding-left: 0;
		color: #333;
		border: 0;
		font-size: 16px;
		font-weight: bold;
		line-height: 42px;
		width: 16px;
		height: 16px;
		margin: 0;
		cursor: pointer;
	}

	.m-unlogin .b-unlogn label {
		display: block;
		float: left;
		height: 16px;
		padding-left: 8px;
		font-size: 12px;
		color: #999;
		line-height: 17px;
		font-size: 14px;
		color: #999;
		line-height: 18px;
	}

	.ckimgbox {
		width: 150px;
		height: 35px;
		display: inline-block;
	}

	.ckimgbox img {
		width: 80px;
		height: 35px;
		float: left;
		margin-top: -5px;
	}

	.ckimgbox a {
		width: 50px;
		height: 35px;
		margin-left: 6px;
		font-size: 16px;
		color: #009040;
		float: left;
	}

	.login {
		width: 400px;
		height: 420px;
		top: 60px;
		right: 0px;
		text-align: left;
		position: absolute;
		z-index: 2;
		background: #fff;
		-webkit-border-radius: 4px;
		border-radius: 4px;
		background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f4f4f4));
		background-image: -webkit-linear-gradient(top, #fff, #f4f4f4);
		background-image: -moz-linear-gradient(top, #fff 0, #f4f4f4 100%);
		background-image: linear-gradient(-180deg, #fff, #f4f4f4);
		-webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .1);
		box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .1)
	}

	.loginForm {
		height: 100%;
		padding: 0;
		-webkit-border-radius: 4px;
		border-radius: 4px;
		background: #fff;
	}

	.loginForm .loginbox-title {
		padding: 30px 0 0;
		color: #333;
		font-size: 20px;
		line-height: 28px;
		text-align: center
	}

	.header-163logo {

		-webkit-background-size: 100% 100%;
		background-size: 100% 100%
	}

	.header-126logo,
	.header-163logo {
		display: inline-block;
		width: 100%;
		height: 40px;
		margin-top: 18px;
	}

	.header {
		padding: 0 40px;
		height: 70px;
		position: relative;
		z-index: 2;
		overflow: hidden
	}

	.headerLogo {
		top: 20px;
		left: 40px
	}

	.headerLogo p {
		display: none
	}

	.headerIntro {
		height: 28px;
		width: 144px;
		display: block;
		background-position: 0 -64px;
		top: 17px;
		left: 194px
	}

	.headerNav {
		top: 27px;
		right: 40px;
		text-align: right;
		line-height: 17px
	}

	.headerNav,
	.headerNav a {
		color: #000;
		font-size: 16px;
		width: 200px;
		position: absolute;
		right: 30px;
		font-weight: 600;
	}

	.headerNav a {
		padding-left: 12px;
		display: inline;
		vertical-align: middle;
		width: 80px;
		position: relative;
		cursor: pointer;
	}

	.headerNav a.separation-line:after {
		content: "";
		display: inline-block;
		vertical-align: middle;
		margin-top: -2px;
		margin-left: 12px;
		width: 1px;
		height: 12px;
		background-color: #c2c2c2;
		font-size: 0
	}

	.headerNav .last {
		padding-left: 0
	}

	.headerTitleAll {
		font-size: 16px;
		font-weight: 600;
		height: 35px;
		line-height: 20px;
		width: 390px;
		display: block;
		position: absolute;
		top: 20px;
		left: 300px;
		border-left: 1px solid #aaa;
		color: #000;
		padding-left: 25px;
	}

	.headerTitleAll .headerTitle {
		margin-top: -5px;
		letter-spacing: 5.5px;
	}

	.headerTitleAll .headerTitle2 {
		margin-top: 3px;
		letter-spacing: 1.5px;
	}

	.footer {
		width: 1100px;
		color: #848585;
		margin: 22px auto 0
	}

	.copyright {
		margin-left: 8px
	}

	.footer-nav a:before {
		content: "";
		display: inline-block;
		vertical-align: middle;
		margin-top: -2px;
		margin-right: 10px;
		width: 1px;
		height: 12px;
		background: #cecece
	}

	.footer-nav a:first-child:before {
		display: none
	}

	.footer-certification {
		line-height: 24px;
		padding: 0;
		margin: 0;
		box-sizing: border-box;
		font-size: 15px;
		color: #999;
	}

	.footer-certification a {
		display: inline-block;
		vertical-align: middle;
		font-size: 15px;
		color: #999;
	}

	.m-footer {
		padding-top: 50px
	}

	.footer-main {
		margin: auto;
		text-align: center;
	}

	.icp {
		padding-right: 0;
		margin-left: 12px;
		color: black;
	}

	.bd ul li img {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue